var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saturnalia-map-wrapper"},[_c('iframe',{staticClass:"sat-iframe",attrs:{"src":"https://dome-zcmp.maillist-manage.eu/ua/Optin?od=12ba7e549127&zx=14ad033c1f&tD=112f9e53a3340faa&sD=112f9e53a37e289b","frameBorder":"0","id":"output-frame-id"}})])
}]

export { render, staticRenderFns }